/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any */
import { Middleware, Action, AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';

type BatchActionType = AnyAction | ThunkAction<any, any, unknown, AnyAction> | false | undefined;
interface BatchAction extends Action {
  actions: BatchActionType[];
}

const BATCH_ACTION = '@@BATCH_ACTION';

const isBatchAction = (action: unknown): action is BatchAction =>
  (action as Action).type === BATCH_ACTION && Array.isArray((action as BatchAction).actions);

export const batchMiddleware: Middleware = store => {
  const dispatchActions = (action: BatchActionType) => {
    isBatchAction(action)
      ? action.actions.filter(Boolean).forEach(dispatchActions)
      : store.dispatch<any>(action);
  };
  return next => action => {
    if (isBatchAction(action)) {
      dispatchActions(action);
    }
    return next(action);
  };
};

export default function batchAction(...actions: BatchActionType[]): BatchAction {
  return {
    type: BATCH_ACTION,
    actions
  };
}
